module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mw7-ns center items-center pa3 mt5"
  }, [(_vm.loading) ? _c('div', [_c('pl-spinner', {
    staticClass: "x2",
    staticStyle: {
      "margin": "auto"
    }
  })], 1) : _c('div', [_vm._m(0), _vm._v(" "), (_vm.users_tab === 'admin-add-users') ? _c('div', {
    staticClass: "row col-xs center-xs no-margin pt4"
  }, [_c('div', {
    staticClass: "mr3"
  }, [_c('div', {
    staticClass: "tc topics-data"
  }, [_vm._v(_vm._s(_vm.summary.teacher))]), _vm._v(" "), _c('div', {
    staticClass: "tc topics-title"
  }, [_vm._v("\n          Teachers\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "ml3"
  }, [_c('div', {
    staticClass: "tc topics-data"
  }, [_vm._v(_vm._s(_vm.summary.student))]), _vm._v(" "), _c('div', {
    staticClass: "tc topics-title"
  }, [_vm._v("Students")])]), _vm._v(" "), (_vm.summary.users_not_added && _vm.summary.users_not_added.length) ? _c('div', {
    staticClass: "col-xs-12 center-xs mt4 fw5"
  }, [_c('div', {
    staticClass: "mb3"
  }, [_vm._v("\n          The following teachers were not added to the school because their\n          accounts are already associated with a different school in Parlay.\n        ")]), _vm._v(" "), _vm._l((_vm.summary.users_not_added), function(user, index) {
    return _c('span', {
      key: index,
      staticClass: "b"
    }, [_vm._v("\n          " + _vm._s(index + 1 !== _vm.summary.users_not_added.length ?
      user.email + ', ' :
      user.email) + "\n        ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "mt3"
  }, [_vm._v("\n          If you have questions about this please click the chat bubble down\n          below.\n        ")])], 2) : _vm._e()]) : _c('div', {
    staticClass: "row center-xs pt4"
  }, [_c('div', {
    staticClass: "col-xs-12 topics-data"
  }, [_vm._v(_vm._s(_vm.summary.courses))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 topics-title"
  }, [_vm._v("\n        Courses\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "row center-xs pt4"
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    staticStyle: {
      "font-size": "16px",
      "font-weight": "550"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.finish.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        FINISH\n      ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center tc"
  }, [_c('span', {
    staticClass: "tc summary-title"
  }, [_vm._v("Success! You have added / updated the following:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-55737b9c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/adminPortalUsers/addUsers/addUsersThirdStep.vue
// module id = 2070
// module chunks = 61